// Service d'envoi d'emails via l'API backend (SendGrid)
import { addAppCheckHeader } from '../utils/appCheck';

// En dev, utiliser une URL relative pour passer par le proxy (setupProxy → localhost:5000)
// et éviter NetworkError / CORS quand le navigateur appelle directement le port 5000.
const API_BASE_URL =
  !process.env.REACT_APP_API_URL || process.env.REACT_APP_API_URL === 'http://localhost:5000'
    ? ''
    : process.env.REACT_APP_API_URL;

export interface ContactFormData {
  isServiceProvider: string;
  firstName: string;
  lastName: string;
  company: string;
  email: string;
  phone: string;
  postalCode: string;
  city: string;
  country: string;
  message: string;
}

export const sendContactEmail = async (formData: ContactFormData): Promise<{ success: boolean; error?: string }> => {
  try {
    const toEmail = 'contact@regexport-conseil.fr'; // Email de destination
    const address = `${formData.postalCode} ${formData.city}, ${formData.country}`;

    console.log('📧 Tentative d\'envoi d\'email de contact via API:', {
      toEmail,
      fromName: `${formData.firstName} ${formData.lastName}`,
      fromEmail: formData.email
    });

    // Appeler l'API backend pour envoyer l'email via SendGrid
    const headers = await addAppCheckHeader({
      'Content-Type': 'application/json',
    });
    
    const response = await fetch(`${API_BASE_URL}/sendContactEmail`, {
      method: 'POST',
      headers,
      body: JSON.stringify({
        fromName: `${formData.firstName} ${formData.lastName}`.trim() || formData.email,
        fromEmail: formData.email,
        firstName: formData.firstName,
        lastName: formData.lastName,
        company: formData.company,
        phone: formData.phone,
        address,
        postalCode: formData.postalCode,
        city: formData.city,
        country: formData.country,
        serviceProvider: formData.isServiceProvider === 'yes' ? 'Oui' : 'Non',
        message: formData.message
      })
    });

    const result = await response.json();

    if (result.success) {
      console.log('✅ Email de contact envoyé avec succès via SendGrid');
      return { success: true };
    } else {
      console.warn('⚠️ Échec de l\'envoi de l\'email:', result.error);
      return { 
        success: false, 
        error: result.error || 'Erreur lors de l\'envoi de l\'email' 
      };
    }

  } catch (error: any) {
    console.error('❌ Erreur lors de l\'envoi de l\'email de contact:', error);
    
    return { 
      success: false, 
      error: `Erreur réseau: ${error.message || 'Impossible de contacter le serveur'}` 
    };
  }
};

export interface ForumNotificationData {
  topicOwnerEmail: string;
  topicTitle: string;
  replyAuthorName: string;
  replyAuthorEmail: string;
  topicId: string;
  categoryId: string;
}

export const sendForumReplyNotificationEmail = async (data: ForumNotificationData): Promise<{ success: boolean; error?: string }> => {
  try {
    // Construire l'URL du topic
    const topicUrl = `${window.location.origin}/forum/topic/${data.topicId}`;

    console.log('📧 Tentative d\'envoi d\'email de notification forum via API:', {
      topicOwnerEmail: data.topicOwnerEmail,
      topicTitle: data.topicTitle,
      replyAuthorName: data.replyAuthorName,
      topicId: data.topicId
    });

    // Appeler l'API backend pour envoyer l'email via SendGrid
    const headers = await addAppCheckHeader({
      'Content-Type': 'application/json',
    });
    
    const response = await fetch(`${API_BASE_URL}/sendForumNotification`, {
      method: 'POST',
      headers,
      body: JSON.stringify({
        topicOwnerEmail: data.topicOwnerEmail,
        topicTitle: data.topicTitle,
        replyAuthorName: data.replyAuthorName,
        replyAuthorEmail: data.replyAuthorEmail,
        topicId: data.topicId,
        topicUrl: topicUrl
      })
    });

    const result = await response.json();

    if (result.success) {
      console.log('✅ Email de notification forum envoyé avec succès via SendGrid');
      return { success: true };
    } else {
      console.warn('⚠️ Échec de l\'envoi de l\'email (non bloquant):', result.error);
      // Ne pas bloquer la création de la réponse si l'email échoue
      return { 
        success: false, 
        error: result.error || 'Erreur lors de l\'envoi de l\'email' 
      };
    }

  } catch (error: any) {
    console.error('❌ Erreur lors de l\'envoi de l\'email de notification forum:', error);
    
    // Ne pas bloquer la création de la réponse si l'email échoue
    return { 
      success: false, 
      error: `Erreur réseau: ${error.message || 'Impossible de contacter le serveur'}` 
    };
  }
};